import { render, staticRenderFns } from "./RealEstateDetailsView.vue?vue&type=template&id=2991215d&scoped=true"
import script from "./RealEstateDetailsView.vue?vue&type=script&lang=ts"
export * from "./RealEstateDetailsView.vue?vue&type=script&lang=ts"
import style0 from "./RealEstateDetailsView.vue?vue&type=style&index=0&id=2991215d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2991215d",
  null
  
)

export default component.exports